import PropTypes from 'prop-types';
import React from 'react';

import withTranslate from '../../app/hoc/with-translate';
import PageMetadata from '../../app/components/page-metadata';
import { getPostSettingsPageTitleKey } from '../services/post-settings';

export const PostSettingsPageMetadata = ({ t }) => <PageMetadata title={getPostSettingsPageTitleKey(t)} />;

PostSettingsPageMetadata.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslate(PostSettingsPageMetadata);
